import { createModuleStore } from '../utils'
import { watch, computed } from 'vue'
import { log } from '@/services/log'

export function useStandardReaderConfigsStore() {
  const storeFn = createModuleStore(
    'standard-reader-configs',
    {
      type: 'Standard Reader Config',
      pageHeading: 'Standard Reader Configs',
      noHistory: true,
      sortingOn: 'toolbar',
      statusesFilterName: 'statuses',
      uploadOptionsCsv: '',
      uri: '/readers/configs/standard',
      serviceUri: '/readers/configs/standard',
      listingModuleName: 'Config',
      listingActivityName: 'View Standard Reader Config',
      formModuleName: 'Config',
      toolsConfig: null,
      showToolsActivityModal: false,
      formActivityName: 'Edit Standard Reader Config',
      allFields: [
        {
          key: 'name',
          title: 'NAME',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'session',
          title: 'SESSION',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'readerType',
          title: 'READER TYPE',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'inventoryStartTrigger',
          title: 'START TRIGGER',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'inventoryStopTrigger',
          title: 'STOP TRIGGER',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'externalId',
          title: 'UUID',
          visible: false,
          sortable: false,
          disabled: false,
        },
        {
          key: 'includeAntennaPortNumber',
          title: 'INCLUDE ANTENNA PORT NUMBER',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includeChannel',
          title: 'INCLUDE CHANNEL',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includeFirstSeenTime',
          title: 'INCLUDE FIRST SEEN TIME',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includeLastSeenTime',
          title: 'INCLUDE LAST SEEN TIME',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includePeakRssi',
          title: 'INCLUDE PEAK RSSI',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includeSeenCount',
          title: 'INCLUDE SEEN COUNT',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'keepAlivePeriodMillis',
          title: 'KEEP ALIVE PERIOD (SECONDS)',
          type: 'millisToSecond',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'reportTrigger',
          title: 'REPORT TRIGGER',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'useTls',
          title: 'USE TLS',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'tagPopulationEstimate',
          title: 'POPULATION ESTIMATE',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'createdBy',
          title: 'CREATED BY',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'createdTimestamp',
          title: 'CREATED TIME',
          type: 'datetime',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'lastModifiedBy',
          title: 'LAST MODIFIED BY',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'lastModifiedTimestamp',
          title: 'LAST MODIFIED TIME',
          type: 'datetime',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'status',
          title: 'STATUS',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'actions',
          title: 'ACTIONS',
          visible: true,
          disabled: true,
          sortable: false,
        },
      ],
    },
    {
      allReaderOptions: [],
    },
    {
      readerOptionsUpdated(values) {
        log('In reader option selected in standard store', values)
        store.allReaderOptions.forEach((opt) => {
          log('Resetting option:', opt.value)
          store.formData[opt.value] = false
        })
        store.formData['options'].forEach((selectedOpt) => {
          log('Setting option to true:', selectedOpt)
          store.formData[selectedOpt] = true
        })
      },
      resetPageFilters() {
        const store = storeFn()
        store.resetBaseFilters()
      },
      copy(item) {
        const obj = {
          session: item.session,
          readerType: item.readerType,
          inventoryStartTrigger: item.inventoryStartTrigger,
          periodicStartTriggerOffsetMillis: item.periodicStartTriggerOffsetMillis,
          periodicStartTriggerPeriodMillis: item.periodicStartTriggerPeriodMillis,
          gpiStartTriggerPort: item.gpiStartTriggerPort,
          gpiStartTriggerValue: item.gpiStartTriggerValue,
          inventoryStopTrigger: item.inventoryStopTrigger,
          gpiStopTriggerPort: item.gpiStopTriggerPort,
          gpiStopTriggerValue: item.gpiStopTriggerValue,
          stopDurationMillis: item.stopDurationMillis,
          reportTrigger: item.reportTrigger,
          tagPopulationEstimate: item.tagPopulationEstimate,
          keepAlivePeriodMillis: item.keepAlivePeriodMillis,
          includePeakRssi: item.includePeakRssi,
          includeChannel: item.includeChannel,
          includeSeenCount: item.includeSeenCount,
          includeFirstSeenTime: item.includeFirstSeenTime,
          includeLastSeenTime: item.includeLastSeenTime,
          includeAntennaPortNumber: item.includeAntennaPortNumber,
          useTls: item.useTls,
        }
        return obj
      },
    },
    {
      actionBindings: {
        options: 'readerOptionsUpdated',
      },
      fields: [
        {
          id: 'standard_reader_reader_type',
          name: 'readerType',
          label: 'Reader Type',
          size: 4,
          component: 'NSelect',
          componentProps: { placeholder: 'Pick reader type' },
          rules: [
            {
              required: true,
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_session',
          name: 'session',
          label: 'Session',
          size: 4,
          defaultValue: 2,
          component: 'NSelect',
          componentProps: { placeholder: 'Pick RFID session', optionsAlias: 'Sessions' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_default_tx_power',
          name: 'defaultTxPower',
          label: 'Default TX Power',
          size: 4,
          component: 'NSelect',
          componentProps: { placeholder: 'Pick TX power' },
          rules: [
            {
              required: true,
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_report_trigger',
          name: 'reportTrigger',
          label: 'Report Trigger',
          size: 4,
          component: 'NSelect',
          componentProps: { placeholder: 'Pick report trigger', optionsAlias: 'ReportTriggers' },
          rules: [
            {
              required: true,
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_start_trigger',
          name: 'inventoryStartTrigger',
          label: 'Start Trigger',
          size: 4,
          component: 'NSelect',
          componentProps: { placeholder: 'Pick start trigger' },
          rules: [
            {
              required: true,
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_periodic_start_trigger_offset_millis',
          name: 'periodicStartTriggerOffsetMillis',
          label: 'Offset',
          size: 6,
          visible: false,
          component: 'ArsTimeInput',
          defaultValue: 0,
          componentProps: { placeholder: 'Enter periodic start offset' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_periodic_start_trigger_period_millis',
          name: 'periodicStartTriggerPeriodMillis',
          label: 'Period',
          size: 6,
          visible: false,
          component: 'ArsTimeInput',
          defaultValue: 10000,
          componentProps: { placeholder: 'Enter periodic start period' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_gpi_start_trigger_port',
          name: 'gpiStartTriggerPort',
          label: 'GPI Start Trigger Port',
          size: 4,
          visible: false,
          component: 'NInputNumber',
          defaultValue: 1,
          componentProps: { placeholder: 'Enter GPI start trigger port' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_gpi_start_trigger_value',
          name: 'gpiStartTriggerValue',
          label: 'GPI Start Trigger Value',
          size: 4,
          visible: false,
          component: 'NCheckbox',
          defaultValue: true,
          componentProps: { placeholder: 'Enter GPI start trigger value' },
          rules: [
            {
              required: true,
              type: 'boolean',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_stop_trigger',
          name: 'inventoryStopTrigger',
          label: 'Stop Trigger',
          size: 4,
          component: 'NSelect',
          componentProps: { placeholder: 'Pick stop trigger' },
          rules: [
            {
              required: true,
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_gpi_stop_trigger_port',
          name: 'gpiStopTriggerPort',
          label: 'GPI Stop Trigger Port',
          size: 4,
          visible: false,
          component: 'NInputNumber',
          defaultValue: 1,
          componentProps: { placeholder: 'Enter GPI stop trigger port' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_gpi_stop_trigger_value',
          name: 'gpiStopTriggerValue',
          label: 'GPI Stop Trigger Value',
          size: 4,
          visible: false,
          component: 'NCheckbox',
          defaultValue: false,
          componentProps: { placeholder: 'Enter GPI stop trigger value' },
          rules: [
            {
              required: true,
              type: 'boolean',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_stop_trigger_duration_millis',
          name: 'stopDurationMillis',
          label: 'Stop duration',
          size: 6,
          visible: false,
          component: 'ArsTimeInput',
          defaultValue: 980,
          componentProps: { placeholder: 'Enter stop trigger duration', showAs: 'millis' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_keep_alive_period_millis',
          name: 'keepAlivePeriodMillis',
          label: 'Keep Alive Period',
          size: 6,
          component: 'ArsTimeInput',
          defaultValue: 5000,
          componentProps: { placeholder: 'Enter keep alive period', showAs: 'millis' },
          rules: [
            {
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_tag_population_estimate',
          name: 'tagPopulationEstimate',
          label: 'Tag Population',
          size: 4,
          component: 'NInputNumber',
          defaultValue: 8,
          componentProps: { placeholder: 'Enter tag population' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_options',
          name: 'options',
          label: 'Reader Options',
          size: 24,
          component: '',
          componentProps: {},
          rules: [
            {
              type: 'array',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_config_name',
          name: 'name',
          label: 'Name',
          size: 24,
          component: 'NInput',
          componentProps: { placeholder: 'Enter descriptive name' },
          rules: [
            {
              required: true,
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'standard_reader_include_peak_rssi',
          name: 'includePeakRssi',
          label: 'Include Peak Rssi',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
        {
          id: 'standard_reader_include_channel',
          name: 'includeChannel',
          label: 'Include Channel',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
        {
          id: 'standard_reader_include_seen_count',
          name: 'includeSeenCount',
          label: 'Include Seen Count',
          size: 4,
          visible: false,
          defaultValue: true,
          componentProps: {},
        },
        {
          id: 'standard_reader_include_first_seen_time',
          name: 'includeFirstSeenTime',
          label: 'Include First Seen Time',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
        {
          id: 'standard_reader_include_last_seen_time',
          name: 'includeLastSeenTime',
          label: 'Include Last Seen Time',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
        {
          id: 'standard_reader_include_antenna_port_number',
          name: 'includeAntennaPortNumber',
          label: 'Include Antenna Port Number',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
        {
          id: 'standard_config_use_tls',
          name: 'useTls',
          label: 'Use Tls',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
      ],
    }
  )
  const store = storeFn()
  const inventoryStartTriggerValue = computed(() => store?.formData?.inventoryStartTrigger ?? 'NULL')
  const gpiStartTriggerFields = ['gpiStartTriggerPort', 'gpiStartTriggerValue']
  const periodicStartTriggerFields = ['periodicStartTriggerOffsetMillis', 'periodicStartTriggerPeriodMillis']
  const inventoryStartTriggerFields = gpiStartTriggerFields + periodicStartTriggerFields
  watch(
    inventoryStartTriggerValue,
    (mode) => {
      const formFields = store.form?.fields
      switch (mode) {
        case 'IMMEDIATE':
        case 'NULL':
          formFields?.filter((d) => inventoryStartTriggerFields.includes(d.name))?.forEach((d) => (d.visible = false))
          break
        case 'PERIODIC':
          formFields?.filter((d) => gpiStartTriggerFields.includes(d.name))?.forEach((d) => (d.visible = false))
          formFields?.filter((d) => periodicStartTriggerFields.includes(d.name))?.forEach((d) => (d.visible = true))
          break
        case 'GPI':
          formFields?.filter((d) => periodicStartTriggerFields.includes(d.name))?.forEach((d) => (d.visible = false))
          formFields?.filter((d) => gpiStartTriggerFields.includes(d.name))?.forEach((d) => (d.visible = true))
          break
      }
    },
    { immediate: true }
  )

  const inventoryStopTriggerValue = computed(() => store?.formData?.inventoryStopTrigger ?? 'NULL')
  const gpiStopTriggerFields = ['gpiStopTriggerPort', 'gpiStopTriggerValue']
  const durationStopTriggerFields = ['stopDurationMillis']
  const inventoryStopTriggerFields = gpiStopTriggerFields + durationStopTriggerFields
  watch(
    inventoryStopTriggerValue,
    (mode) => {
      const formFields = store.form?.fields
      switch (mode) {
        case 'NULL':
          formFields?.filter((d) => inventoryStopTriggerFields.includes(d.name))?.forEach((d) => (d.visible = false))
          break
        case 'DURATION':
          formFields?.filter((d) => gpiStopTriggerFields.includes(d.name))?.forEach((d) => (d.visible = false))
          formFields?.filter((d) => durationStopTriggerFields.includes(d.name))?.forEach((d) => (d.visible = true))
          break
        case 'GPI_WITH_TIMEOUT':
          formFields?.filter((d) => inventoryStopTriggerFields.includes(d.name))?.forEach((d) => (d.visible = true))
          break
      }
    },
    { immediate: true }
  )

  return store
}
